export function getSizeClasses(size) {
  if (size === 'xs') return 'h-6 w-6'
  else if (size === 'sm') return 'h-8 w-8'
  else if (size === 'md') return 'h-10 w-10'
  else if (size === 'lg') return 'h-12 w-12'
  else if (size === 'xl') return 'h-14 w-14'
  else if (size === '3xl') return 'h-20 w-20'
}
